export default __webpack_public_path__ + "static/media/cardimage7.60504c5b.png";